module.exports = __webpack_public_path__ + "media/your_career_track/background-893f19d7.png";